module.exports = "/images/linkedin.png?067d502ea2dd8e382c81b0517e910c0e";